<!-- Translated: skip -->
<template>
  <Modal @close="closeModalLocal" :wide="true">
    <div slot="header">
      <div class="modal-header" :style="'background-image:url(' + (unit && unit.pool && unit.pool.image) + ')'">
        <div class="heading" v-if="unit">
          {{ (unit.display_name || unit.description_title) }}
        </div>
      </div>
    </div>
    <div class="modal-content" v-if="unit">
      <div class="content-left">
        <div class="tabs">
          <div :class="[
            'tab',
            activeTab === 'info' && 'active',
          ]" @click="setTab('info')">
            <icon name="info-blue" :scale="1.5" class="icon icon-inactive"></icon>
            <icon name="info-white" :scale="1.5" class="icon icon-active"></icon>
            <div>Beskrivning</div>
          </div>
          <div :class="[
            'tab',
            activeTab === 'images' && 'active',
          ]" @click="setTab('images')">
            <icon name="img-blue" :scale="1.5" class="icon icon-inactive"></icon>
            <icon name="img-white" :scale="1.5" class="icon icon-active"></icon>
            <div>Bilder</div>
          </div>
          <div :class="[
            'tab',
            activeTab === 'map' && 'active',
          ]" @click="setTab('map')">
            <icon name="map-blue" :scale="1.5" class="icon icon-inactive"></icon>
            <icon name="map-white" :scale="1.5" class="icon icon-active"></icon>
            <div>Karta</div>
          </div>
          <div :class="[
            'tab',
            activeTab === 'video' && 'active',
          ]" @click="setTab('video')">
            <icon name="play-blue" :scale="1.5" class="icon icon-inactive"></icon>
            <icon name="play-white" :scale="1.5" class="icon icon-active"></icon>
            <div>Film</div>
          </div>
        </div>
        <div v-if="activeTab === 'info'" class="info" v-html="nl2br(unit.description_full)">
        </div>
        <div v-if="activeTab === 'images'" class="images">
          <agile
              :arrows="true"
              :speed="200"
              :timing="'linear'"
              :fade="false"
              :autoplay="false"
              arrow='<img src="https://static.booking.branasgruppen.se/static/svg/arrow-slideshow-left.svg" />'
          >
            <div class="slide" v-for="image in unit.images">
              <img :src="image.path_corrected" />
            </div>
          </agile>
        </div>
        <div v-if="activeTab === 'video'" class="video">
          <Vimeo :url="unit.pool.video" />
        </div>
      </div>
      <div class="content-right">
        <AccomodationPeriodConfirm v-if="arrival" class="tighter" :unit="unit" :arrival="arrival" :departure="departure"></AccomodationPeriodConfirm>
        <button v-if="!$store.state.tempCartAccomodation.period" @click="openModal(['UnitPriceModal', {unit}])">Priser och tillgänglighet <icon name="arrow-white" :scale="1.2" /></button>
        <button v-if="$store.state.tempCartAccomodation.period" @click="chooseAccomodation({pool_lid: unit.pool_lid, unit_lid: unit.unit_lid, period: $store.state.tempCartAccomodation.period, week: $store.state.tempCartAccomodation.period.week, name: (unit.display_name || unit.description_title), capacity: unit.capacity, price: $store.state.tempCartAccomodation.period.price})">Välj <icon name="cart-white" :scale="1.2" /></button>
        <button v-if="!isFavorite(unit.id)" class="white small border" @click="toggleFavorite(unit.id)">
          <icon name="heart" :scale="1.5" /> Spara
        </button>
        <button v-if="isFavorite(unit.id)" class="white small border" @click="toggleFavorite(unit.id)">
          <icon name="heart-red" :scale="1.5" /> Ta bort
        </button>
        <UnitFacts :unit="unit"></UnitFacts>
      </div>
    </div>
    <pre v-if="false">{{ unit }}</pre>
  </Modal>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import Modal from '@/components/components/Modal';
import UnitFacts from '@/components/parts/Accomodation/UnitFacts';
import API from '@/classes/API';
import AccomodationPeriodConfirm from '@/components/parts/Accomodation/AccomodationPeriodConfirm';
import Vimeo from '@/components/components/Vimeo';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    UnitFacts,
    AccomodationPeriodConfirm,
    Vimeo,
  },
  data() {
    return {
      activeTab: 'info',
      unit: null,
      loaded: false,
      price: null,
      arrival: null,
      departure: null,
    };
  },
  async mounted() {
    let data = {};
    if (this.$route.params.slug) {
      data = await API.get(`/units/${this.$route.params.slug}/info`);
    } else {
      data = await API.get(`/units/${this.$route.params.poolId}/${this.$route.params.unitId}/info`);
    }
    this.loaded = true;
    this.unit = data.data;

    this.arrival = this.params.arrival;
    this.departure = this.params.departure;
  },
  computed: {
    ...mapGetters([
      'confirmedAccomodations',
      'favoriteAccommodations',
    ]),
  },
  methods: {
    closeModalLocal() {
      if (this.$route.query.ref) {
        this.$router.push({ path: `/${this.$route.query.flow}` });
      }
      this.closeModal();
    },
    setTab(tab) {
      if (tab === 'map') {
        this.openModal([`MapModal${this.SITE_CONFIG.site}`, {
          locationId: this.unit.facility.id,
        }]);
      } else {
        this.activeTab = tab;
      }
    },
    isFavorite(id) {
      return this.favoriteAccommodations.includes(id);
    },
    toggleFavorite(unitId) {
      const index = this.favoriteAccommodations.indexOf(unitId);
      if (index > -1) {
        this.removeFavorite(index);
      } else {
        const $this = this;
        const favoriteCount = this.favoriteAccommodations.length;
        if (favoriteCount >= 3) {
          this.openModal(['GeneralModal', {
            title: 'Max 3 favoritboenden',
            content: '<p>Du kan endast spara 3 favoritboenden.</p>',
            buttons: [
              {
                title: 'Okej',
                class: 'small',
                click: () => {
                  $this.closeModal();
                },
              },
            ],
          }]);
        } else {
          this.addFavorite(unitId);
        }
      }
    },
    ...mapMutations([
      'closeModal',
      'openModal',
      'accomodationPeriodPick',
      'accomodationPeriodPick',
      'closeModal',
      'closeAllModals',
      'openModal',
      'pickAccomodation',
      'addFavorite',
      'removeFavorite',
    ]),
    didChooseAccomodation(payload) {
      const p = payload;
      p.unit = this.unit;
      p.unit_code = this.unit.unit_code || this.unit.name;
      p.description_title = this.unit.description_title;
      p.site = this.unit.facility_id;
      this.pickAccomodation(p);
      this.closeAllModals();
      this.$store.state.tempCartAccomodation = {};

      const no = this.$store.state.cart.accomodations.length - 1;
      this.$router.push({ name: 'confirm-accomodation', query: { d: new Date().getTime(), no } });
    },
    chooseAccomodation(payload) {
      this.didChooseAccomodation(payload);
    },
    nl2br(input) {
      /* eslint-disable */
      var breakTag = '<br>';
      return (input.toString()).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.modal-content
  display flex
  padding 30px 0

.content-left
  border-right 1px solid silver-light
  flex none
  width 50%
  box-sizing border-box
  padding 10px 50px

.content-right
  border-right 1px solid silver-light
  flex none
  width 50%
  box-sizing border-box
  padding 10px 50px
  .image-holder
    display inline-block
    float left
    margin-right 10px
    img
      width 50px

  button
    margin-bottom 25px


.tabs
  display flex
  align-items stretch
  margin-bottom space-3

.tab
  background pale-sky
  flex 1 1 0
  border-right 1px solid alpha(deep-sea-blue, .2)
  font-size 12px
  padding space-1
  font-weight bold
  text-transform uppercase
  text-align center
  cursor pointer
  .icon
    margin space-half 0
    color deep-sea-blue
    &.icon-inactive
      display inline-block
    &.icon-active
      display none
  &:hover:not(.active)
    fill-shadow(light-blue-gray, .5)
    display inline-block
  &.active
    background deep-sea-blue
    color white
    position relative
    .icon
      color inherit
      &.icon-inactive
        display none
      &.icon-active
        display inline-block
    &:after
      color deep-sea-blue
      content ''
      display block
      position absolute
      bottom 0
      left 50%
      margin-left -10px
      margin-bottom -10px
      border-top 10px solid currentColor
      border-right 10px solid transparent
      border-bottom 0
      border-left 10px solid transparent
  &:first-child
    border-top-left-radius 3px
    border-bottom-left-radius 3px
  &:last-child
    border-top-right-radius 3px
    border-bottom-right-radius 3px
    border-right none

.modal-header
  background silver
  height 420px
  display flex
  justify-content center
  align-items flex-end
  margin -space-2 -space-2 0 -space-2
.heading
  united-heavy()
  font-size 30px
  text-transform uppercase
  background white
  padding 25px 30px 20px 30px
  border-radius 4px 4px 0 0

.info
  font-size 15px
  line-height 1.4
  p
    line-height inherit
    margin-bottom 1.4em

.preamble
  font-size 17px
  font-weight bold

.bold
  font-weight bold

.modal-header
  background-position center
  background-size cover

</style>



// WEBPACK FOOTER //
// UnitInfoModal.vue?6f956203